export default class Testimonials extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    this.autoPlay = this.data.autoPlay;
    this.autoPlayDuration = this.data.autoPlayDuration;
    this.animateOutDuration = this.data.animateOutDuration;
    this.animateInDelay = this.data.animateInDelay;

    this.container = el;
    this.slider = el.querySelector('[data-testimonials-slider]');
    this.sliderSlides = [...this.slider.children];
    this.navigationCurrentSlide = el.querySelector('[data-testimonials-slider-current-slide]');
    this.navigationArrowPrevious = el.querySelectorAll('[data-testimonials-slider-previous]');
    this.navigationArrowNext = el.querySelectorAll('[data-testimonials-slider-next]');

    this.dragThreshold = 100;

    this.state = {
      selectedSlideIndex: 0,
      autoPlayInterval: null,
      startX: null,
      dragX: null,
      isDragging: false,
      dragDirection: null
    };

    if (this.sliderSlides.length < 2) return;

    this._registerEventListeners();
    this.startAutoPlay();
  }

  // Event listeners

  _registerEventListeners() {
    // controls
    this.navigationArrowPrevious.forEach(prev => {
      this.events.register(prev, 'click', e => {
        e.preventDefault();
        this.goToSlide(this.state.selectedSlideIndex - 1);
      });
    });
    this.navigationArrowNext.forEach(next => {
      this.events.register(next, 'click', e => {
        e.preventDefault();
        this.goToSlide(this.state.selectedSlideIndex + 1);
      });
    });

    // swipe gestures
    this.events.register(this.slider, 'pointerdown', e => { this._handleDragStart(e) });
    this.events.register(this.slider, 'pointermove', e => { this._handleDrag(e) });
    this.events.register(this.slider, 'pointerup', e => { this._handleDragEnd(e) });
    this.events.register(this.slider, 'pointercancel', e => { this._handleDragEnd(e) });

    // TODO: pause autoplay on hover?
    // TODO: disable text selection (firefox)?

    // theme editor events
    this.events.register(document, 'shopify:block:select', e => {
      const slideIndex = this.sliderSlides.indexOf(e.target);
      if (slideIndex > -1) {
        this.goToSlide(slideIndex);
      }
    });
  }

  // Navigate

  goToSlide(index) {
    const numSlides = this.sliderSlides.length;
    const targetIndex = (index + numSlides) % numSlides;
    const targetSlide = this.sliderSlides[targetIndex];
    const currentSlide = this.sliderSlides[this.state.selectedSlideIndex];
    const displayPosition = targetIndex + 1;
    const timeoutDuration = this.data.animateOutDuration + this.data.animateInDelay;

    if (!targetSlide || !currentSlide) return;
    this.state.selectedSlideIndex = targetIndex;
    this.sliderSlides.forEach(slide => {
      slide.classList.remove('block-quote--fade-in');
    });
    this.resetAutoPlay();

    requestAnimationFrame(() => {
      currentSlide.classList.add('block-quote--fade-out');
      setTimeout(() => {
        targetSlide.classList.add('block-quote--fade-in');
        currentSlide.classList.remove('block-quote--fade-out');
        this.slider.style.setProperty('--slide-index', targetIndex);
        this.navigationCurrentSlide.innerText = displayPosition;
      }, timeoutDuration);
    });
  }

  // Autoplay

  startAutoPlay() {
    if (this.autoPlay && this.autoPlayDuration) {
      this.state.autoPlayInterval = setInterval(() => {
        this.goToSlide(this.state.selectedSlideIndex + 1);
        window.myTime = 0;
      }, this.autoPlayDuration);
    }
  }

  stopAutoPlay() {
    if (this.state.autoPlayInterval) {
      clearInterval(this.state.autoPlayInterval);
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }

  _toggleDragIntent(addRemove) {
    if (!addRemove) return;
    if (this.state.dragDirection == 1) {
      this.navigationArrowPrevious.forEach(prev => {
        prev.classList[addRemove]('drag-intent');
      });
    } else if (this.state.dragDirection == -1) {
      this.navigationArrowNext.forEach(next => {
        next.classList[addRemove]('drag-intent');
      });
    }
  }

  // Swipe gesture handlers

  _handleDragStart(e) {
    this.state.startX = e.clientX;
    this.state.isDragging = true;
  }

  _handleDrag(e) {
    if (!this.state.isDragging || typeof this.state.startX !== 'number') return;
    const isOverThreshold = (Math.abs(this.state.dragX) >= this.dragThreshold);
    this.state.dragX = e.clientX - this.state.startX;

    e.preventDefault();
    this.state.dragDirection = Math.sign(this.state.dragX);

    if (isOverThreshold) {
      this._toggleDragIntent('add');
    } else {
      this._toggleDragIntent('remove');
    }
  }

  _handleDragEnd(e) {
    if (!this.state.isDragging || !this.state.dragDirection) return;
    if (Math.abs(this.state.dragX) < this.dragThreshold) return;
    const currentIdx = this.state.selectedSlideIndex;
    const numSlides = this.sliderSlides.length;
    const isFirst = currentIdx == 0;
    const isLast = currentIdx + 1 == numSlides;

    if (isLast && this.state.dragDirection == -1) {
      this.state.selectedSlideIndex = 0;
    } else if (isFirst && this.state.dragDirection == 1) {
      this.state.selectedSlideIndex = numSlides - 1;
    } else {
      this.state.selectedSlideIndex -= this.state.dragDirection;
    }

    this.goToSlide(this.state.selectedSlideIndex);
    this._clearDrag();    
  }

  _clearDrag() {
    this._toggleDragIntent('remove');
    this.state.startX = null;
    this.state.dragX = null;
    this.state.isDragging = false;
    this.state.dragDirection = null;
  }
}
